import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4902 17.354C11.3992 17.6109 12.3586 17.6296 13.2768 17.4081L9.11428 21.583C6.66658 20.8391 4.5974 19.1782 3.33507 16.9443C2.07274 14.7105 1.71392 12.0746 2.33289 9.5823C2.95112 7.08982 4.50057 4.93189 6.66001 3.55586C8.81946 2.17984 11.4233 1.69127 13.9317 2.19143C13.9317 2.19143 10.5578 5.53743 8.72048 7.37626C8.1413 7.92976 7.63566 8.55602 7.21609 9.23953C6.5769 10.288 6.31447 11.5248 6.47246 12.744C6.63045 13.9631 7.19933 15.0912 8.08443 15.9404C8.75292 16.6103 9.58119 17.097 10.4902 17.354Z"
      fill="white"
    />
    <path
      d="M10.7141 6.59581C11.6322 6.37395 12.5917 6.3924 13.5006 6.64937C14.4096 6.90634 15.2378 7.39325 15.9059 8.06353C17.7267 9.89292 18.0823 12.6078 16.7676 14.7544C16.3473 15.4384 15.8417 16.0657 15.2632 16.621C13.4253 18.4571 10.0515 21.8053 10.0515 21.8053C12.5622 22.3104 15.17 21.8245 17.3333 20.4485C19.4965 19.0726 21.0487 16.9123 21.6674 14.4167C22.287 11.9212 21.9262 9.28192 20.6599 7.04655C19.3936 4.81118 17.319 3.15135 14.8667 2.4115L10.7141 6.59581Z"
      fill="white"
    />
  </svg>
)
